import React, { useEffect, useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import '../styles/closingStatusChart.scss';
import { ShipmentService } from '../services/shipmentService';
import Spinner from './spinner';
import Json from './json';


interface IClosingData {
	unshipped: number;
	reconciling: number;
	escalated: number;
	reviewing: number;
	auditing: number;
	qbEntry: number;
	qbAudit: number;
	complete: number;
}

const months = [
	"",//Empty name at 0 so we don;t have to remember to correct the month number to get the right name from the array
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
]

const ClosingStatusChart: React.FunctionComponent = ({ }) => {
	const [isLoading, setIsLoading] = useState(true);
	const [closingData, setClosingData] = useState<IClosingData | undefined>();
	const [month, setMonth] = useState<number>();
	const [year, setYear] = useState<number>();

	useEffect(() => {
		const currentDate = new Date();
		let month = currentDate.getMonth() + 1;
		let year = currentDate.getFullYear();

		if(month == 1){
			month = 12;
			year += -1;
		}
		else{
			month += -1;
		}

		setMonth(month);
		setYear(year);

		setIsLoading(true);
		ShipmentService.getClosingStatus(month, year)
			.then((response) => {
				console.log('ShipmentService.getClosingStatus: SUCCESS', response);
				let data: IClosingData = {
					unshipped: response.data.statusCounts.unshipped,
					reconciling: response.data.statusCounts.reconciling,
					escalated: response.data.statusCounts.escalated,
					reviewing: response.data.statusCounts.reviewing,
					auditing: response.data.statusCounts.auditing,
					qbEntry: response.data.statusCounts.qbEntry,
					qbAudit: response.data.statusCounts.qbAudit,
					complete: response.data.statusCounts.complete
				}
				
				setClosingData(data);
			})
			.catch((error) => {
				console.log('ShipmentService.getClosingStatus', error);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, [])

	return (
		<>
			<section className="hwi-closing-status-chart">
				<section className="management-page-header">
						<div className="title">Closing Status: {months[month]}, {year}</div>
						<div className="actions">

						</div>
					</section>
				<Spinner dependency={isLoading} text='Loading...'>
					<div className='bar'>
						{closingData?.reconciling > 0 &&
							<div className='reconciling' style={{ flex: closingData?.reconciling }}>{closingData?.reconciling}</div>
						}
						{closingData?.escalated > 0 &&
							<div className='escalated' style={{ flex: closingData?.escalated }}>{closingData?.escalated}</div>
						}
						{closingData?.reviewing > 0 &&
							<div className='reviewing' style={{ flex: closingData?.reviewing }}>{closingData?.reviewing}</div>
						}
						{closingData?.auditing > 0 &&
							<div className='auditing' style={{ flex: closingData?.auditing }}>{closingData?.auditing}</div>
						}
						{closingData?.qbEntry > 0 &&
							<div className='qbEntry' style={{ flex: closingData?.qbEntry }}>{closingData?.qbEntry}</div>
						}
						{closingData?.qbAudit > 0 &&
							<div className='qbAudit' style={{ flex: closingData?.qbAudit }}>{closingData?.qbAudit}</div>
						}
						{closingData?.complete > 0 &&
							<div className='complete' style={{ flex: closingData?.complete }}>{closingData?.complete}</div>
						}
					</div>
					<div className='cards'>
						<div className='reconciling'>
							<div className='value'>{closingData?.reconciling}</div>
							<div className='name'>Reconciling</div>
						</div>
						<div className='escalated'>
							<div className='value'>{closingData?.escalated}</div>
							<div className='name'>Escalated</div>
						</div>
						<div className='reviewing'>
							<div className='value'>{closingData?.reviewing}</div>
							<div className='name'>Reviewing</div>
						</div>
						<div className='auditing'>
							<div className='value'>{closingData?.auditing}</div>
							<div className='name'>Auditing</div>
						</div>
						<div className='qbEntry'>
							<div className='value'>{closingData?.qbEntry}</div>
							<div className='name'>QB Entry</div>
						</div>
						<div className='qbAudit'>
							<div className='value'>{closingData?.qbAudit}</div>
							<div className='name'>QB Audit</div>
						</div>
						<div className='complete'>
							<div className='value'>{closingData?.complete}</div>
							<div className='name'>Complete</div>
						</div>
					</div>
				</Spinner>
			</section>
			{/* <Json data={closingData} title='Closing Data:'></Json> */}
		</>
	)
}

export default ClosingStatusChart;